import React from 'react';
import { useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Joi from 'joi';
import {InputLabel, MenuItem, FormControl, Select, Checkbox, FormControlLabel} from '@mui/material';
import {Operator} from "../../../classes/Operator";

function AssetMissionOperatorLayout(props: {
    title: string,
    operatorList?: Operator[],
    onSubmit: Function,
    onCancel: Function
}) {

    const [isPendingSubmit, setPendingSubmit] = useState<boolean>(false)
    const [inputOperatorId, setInputOperatorId] = useState<number | undefined>(undefined)
    const [inputIsRPIC, setInputIsRPIC] = useState<boolean>(false)
    const [inputIsMO, setInputIsMO] = useState<boolean>(false)
    const [inputIsVO, setInputIsVO] = useState<boolean>(false)

    const isOperatorIdValid = Joi.number().integer().positive().required().validate(inputOperatorId);
    const isValid = (!isOperatorIdValid.error);

    function handleSubmit() {
        setPendingSubmit(true);
        props.onSubmit(inputOperatorId, inputIsRPIC, inputIsMO, inputIsVO)
    }

    const bottomControls = isPendingSubmit === true ? (<Typography>Loading...</Typography>) : [(<Button variant='text' onClick={() => props.onCancel()}>Cancel</Button>), (<Button variant='contained' disabled={!isValid} onClick={handleSubmit}>Submit</Button>)];

    if (props.operatorList === undefined) {
        return (<Typography variant="h6">Loading...</Typography>)
    }

    return (
        <Stack direction="column" spacing={1}>
            <Typography variant="h6">{props.title}</Typography>
            <FormControl fullWidth disabled={isPendingSubmit}>
                <InputLabel id="operator-select">Select Operator</InputLabel>
                <Select
                    labelId="operator-select"
                    label="Select Operator"
                    disabled={isPendingSubmit}
                    value={inputOperatorId}
                    onChange={(event: any) => setInputOperatorId(event.target.value)}
                >
                    <MenuItem value={undefined}>none</MenuItem>
                    {props.operatorList.map((p) => (<MenuItem value={p.id}>{p.callsign}</MenuItem>))}
                </Select>
            </FormControl>
            <Stack direction="row" spacing={4} justifyContent="center">
                <FormControlLabel
                    label="RPIC"
                    disabled={isPendingSubmit}
                    control={<Checkbox checked={inputIsRPIC} onChange={(event: any) => setInputIsRPIC(event.target.checked)} />}
                />
                <FormControlLabel
                    label="MO"
                    disabled={isPendingSubmit}
                    control={<Checkbox checked={inputIsMO} onChange={(event: any) => setInputIsMO(event.target.checked)} />}
                />
                <FormControlLabel
                    label="VO"
                    disabled={isPendingSubmit}
                    control={<Checkbox checked={inputIsVO} onChange={(event: any) => setInputIsVO(event.target.checked)} />}
                />
            </Stack>
            <Stack direction="row" spacing={1} justifyContent="right">{bottomControls}</Stack>
        </Stack>
    );
}

export default AssetMissionOperatorLayout;